// @flow

import * as React from "react";

import LinkHandler from "../atoms/LinkHandler";
import usePageFromStore from "../../hooks/usePageFromStore";

import { type BreadcrumbLinkType } from "../../types/";

type PropsType = {
    breadcrumbs?: BreadcrumbLinkType[],
    prependBreadcrumbs?: any,
    colorInverted?: boolean,
    customPageTitle?: string,
};

const Breadcrumbs = (props: PropsType): React.Node => {
    const classList = ["breadcrumbs"];
    const { page } = usePageFromStore();

    // special handling for page breadcrumbs to prevent "my account" double up
    const handledPageBreadcrumbs = page.breadcrumbs
        ? page.breadcrumbs.filter(breadcrumb => {
              return breadcrumb.title !== "My account";
          })
        : [];

    let breadcrumbs: BreadcrumbLinkType[] = props.breadcrumbs
        ? props.breadcrumbs
        : handledPageBreadcrumbs || [];

    // push prepend manual breadcrumbs to start if passsed
    if (props.prependBreadcrumbs) {
        breadcrumbs = [...props.prependBreadcrumbs, ...breadcrumbs];
    }

    if (!breadcrumbs || breadcrumbs.length < 1) return null;

    if (props.colorInverted) {
        classList.push("breadcrumbs--inverted");
    }

    return (
        <ol className={`${classList.join(" ")}`}>
            {breadcrumbs.map((link: any, index: number): React.Node => (
                <li
                    key={index}
                    className="breadcrumbs__single breadcrumb__single--home"
                >
                    <LinkHandler
                        to={link.url}
                        type={link.type ? link.type : ""}
                        onClick={link.onClick}
                    >
                        {link.title}
                    </LinkHandler>
                </li>
            ))}

            {props.customPageTitle || page.post_title ? (
                <li className="breadcrumbs__single breadcrumb__single--home">
                    <span>
                        {props.customPageTitle
                            ? props.customPageTitle
                            : page.post_title}
                    </span>
                </li>
            ) : null}
        </ol>
    );
};

export default Breadcrumbs;
